'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _dec3, _class; // Lib


// Components


// Styles


// Util


// Drop Utils


// Constants


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _shallowequal = require('shallowequal');

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _lodash = require('lodash');

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _recompose = require('recompose');

var _ElementDropTarget = require('../dnd/ElementDropTarget');

var _ElementDropTarget2 = _interopRequireDefault(_ElementDropTarget);

var _elementLineEdgeDropTarget = require('../line/elementLineEdgeDropTarget');

var _elementLineEdgeDropTarget2 = _interopRequireDefault(_elementLineEdgeDropTarget);

var _navigateOnHoverDecorator = require('../dnd/navigateOnHoverDecorator');

var _navigateOnHoverDecorator2 = _interopRequireDefault(_navigateOnHoverDecorator);

var _Board = require('./Board');

var _Board2 = _interopRequireDefault(_Board);

var _permissionsService = require('../../utils/permissions/permissionsService');

var _navigationActions = require('../../reducers/navigationActions');

var _elementIconActions = require('../../components/elementIcon/elementIconActions');

var _inboxDropLocationFn = require('../../inbox/inboxDropLocationFn');

var _inboxDropLocationFn2 = _interopRequireDefault(_inboxDropLocationFn);

var _permissionUtil = require('../../../common/permissions/permissionUtil');

var _makeCanDropFn = require('../dnd/canDrop/makeCanDropFn');

var _makeCanDropFn2 = _interopRequireDefault(_makeCanDropFn);

var _preventDropOnSelfPredicate = require('../dnd/canDrop/preventDropOnSelfPredicate');

var _preventDropOnSelfPredicate2 = _interopRequireDefault(_preventDropOnSelfPredicate);

var _preventLinePredicate = require('../dnd/canDrop/preventLinePredicate');

var _preventLinePredicate2 = _interopRequireDefault(_preventLinePredicate);

var _elementConstants = require('../../../common/elements/elementConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var dropPermittedSelector = function dropPermittedSelector() {
    return (0, _reselect.createSelector)(_permissionsService.currentBoardUserPermissionsSelector, (0, _permissionsService.createElementUserPermissionsSelector)(), function (currentBoardPermissions, boardPermissions) {
        var dropPermitted = (0, _permissionUtil.canWrite)(boardPermissions) && (0, _permissionUtil.canWrite)(currentBoardPermissions) && (0, _permissionUtil.canSave)(boardPermissions) === (0, _permissionUtil.canSave)(currentBoardPermissions);
        return dropPermitted;
    });
};

var makeBoardSelector = function makeBoardSelector() {
    return (0, _reselect.createSelector)(dropPermittedSelector(), function (dropPermitted) {
        return { dropPermitted: dropPermitted };
    });
};

var mapDispatchToProps = function mapDispatchToProps() {
    return function (dispatch) {
        return {
            dispatchNavigateToBoard: function dispatchNavigateToBoard(boardId, keepSelection) {
                return dispatch((0, _navigationActions.navigateToBoard)({ boardId: boardId, keepSelection: keepSelection }));
            },
            dispatchFindDefaultIcon: function dispatchFindDefaultIcon(id, title, transactionId) {
                return dispatch((0, _elementIconActions.findDefaultIcon)({ id: id, query: title, transactionId: transactionId }));
            }
        };
    };
};

var dropTargetConfig = {
    drop: _inboxDropLocationFn2.default,
    canDrop: (0, _makeCanDropFn2.default)([_preventDropOnSelfPredicate2.default, _preventLinePredicate2.default])
};

var BoardContainer = (_dec = (0, _reactRedux.connect)(makeBoardSelector, mapDispatchToProps), _dec2 = (0, _recompose.branch)(function (props) {
    return props.isAlias;
}, _lodash.identity, _elementLineEdgeDropTarget2.default), _dec3 = (0, _ElementDropTarget2.default)(dropTargetConfig, _elementConstants.DROP_TARGET_TYPES.BOARD), _dec(_class = _dec2(_class = _dec3(_class = (0, _navigateOnHoverDecorator2.default)(_class = function (_React$Component) {
    _inherits(BoardContainer, _React$Component);

    function BoardContainer() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, BoardContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BoardContainer.__proto__ || Object.getPrototypeOf(BoardContainer)).call.apply(_ref, [this].concat(args))), _this), _this.onHeadingClick = function (event) {
            var _this$props = _this.props,
                isEditing = _this$props.isEditing,
                element = _this$props.element,
                startEditing = _this$props.startEditing;

            event.stopPropagation();
            if (isEditing) return;

            startEditing(element.get('id'));
        }, _this.onTitleEditDone = function (_ref2) {
            var title = _ref2.title,
                transactionId = _ref2.transactionId;
            var _this$props2 = _this.props,
                element = _this$props2.element,
                dispatchFindDefaultIcon = _this$props2.dispatchFindDefaultIcon;

            if (element.getIn(['content', 'icon', 'id'])) return;

            dispatchFindDefaultIcon(element.get('id'), title, transactionId);
        }, _this.onDoubleClick = function (event) {
            var elementEvents = _this.props.elementEvents;

            _this.navigateToBoard(event);
            elementEvents.onDoubleClick(event);
        }, _this.onClick = function (event) {
            var _this$props3 = _this.props,
                documentMode = _this$props3.documentMode,
                element = _this$props3.element,
                dispatchNavigateToBoard = _this$props3.dispatchNavigateToBoard,
                elementEvents = _this$props3.elementEvents;

            if (documentMode) return dispatchNavigateToBoard(element.get('id'));
            return elementEvents.onClick(event);
        }, _this.navigateToBoard = function (event) {
            var _this$props4 = _this.props,
                element = _this$props4.element,
                dispatchNavigateToBoard = _this$props4.dispatchNavigateToBoard;

            dispatchNavigateToBoard(element.get('id'));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(BoardContainer, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var currentlyShowingHoverStyle = this.props.isHovered && this.props.canDrop;
            var nextShowingHoverStyle = nextProps.isHovered && nextProps.canDrop;

            if (currentlyShowingHoverStyle !== nextShowingHoverStyle) {
                var domNode = _reactDom2.default.findDOMNode(this);
                nextShowingHoverStyle ? domNode.classList.add('can-drop') : domNode.classList.remove('can-drop');
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            // Check for shallow equality on everything.
            return !(0, _shallowequal2.default)(this.props, nextProps, function (thisValue, nextValue, key) {
                // Don't update on is hovered or canDrop to prevent re-rendering many times while dragging
                // Rely on the componentWillReceiveProps to do some class updates imperatively
                if (key === 'isHovered' || key === 'canDrop') return true;
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_Board2.default, _extends({}, this.props, {
                navigateToBoard: this.navigateToBoard,
                onHeadingClick: this.onHeadingClick,
                onClick: this.onClick,
                onDoubleClick: this.onDoubleClick,
                onTitleEditDone: this.onTitleEditDone }));
        }
    }]);

    return BoardContainer;
}(_react2.default.Component)) || _class) || _class) || _class) || _class);
exports.default = BoardContainer;


BoardContainer.propTypes = {
    element: _propTypes2.default.object.isRequired,
    isEditing: _propTypes2.default.bool,
    documentMode: _propTypes2.default.bool,
    dispatchFindDefaultIcon: _propTypes2.default.func,
    dispatchNavigateToBoard: _propTypes2.default.func,
    startEditing: _propTypes2.default.func,
    isHovered: _propTypes2.default.bool,
    canDrop: _propTypes2.default.bool,
    elementEvents: _propTypes2.default.object,
    isAlias: _propTypes2.default.bool
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/board/BoardContainer.js
// module id = 720
// module chunks = 0